/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { getImageDimensions, sendApiRequest } from '../lib/helper';
import { ICourseWorkFlat } from '../types/IAssignment';

const imageExtensions = [".png", ".jpg", ".jpeg", ".gif" ];

const ImageSize: React.FunctionComponent<{ file: ICourseWorkFlat; }> = ({ file }) => {

    const [imageSize, setImageSize] = React.useState("N/A");

    React.useEffect(() => {
        if(imageExtensions.includes(file.FileExtension.toLowerCase()))
        {
            const url = `/api/blobStorage/getBlobAsBase64FromPath?path=${encodeURIComponent(file.FilePath)}`;
            sendApiRequest(url, "GET").then(res => {
                getImageDimensions(res).then((size: {w: number, h: number}) => {
                    setImageSize(`${size.w} x ${size.h}`);
                })
            });

            return () => {
                setImageSize("")
            }
        }
        else{
            setImageSize("N/A");
        }
    }, [file.FilePath])

    return <span>{imageSize}</span>;
};

export default ImageSize;